import { render, staticRenderFns } from "./CardViagens.vue?vue&type=template&id=74a6ba20&scoped=true"
import script from "./CardViagens.vue?vue&type=script&lang=js"
export * from "./CardViagens.vue?vue&type=script&lang=js"
import style0 from "./CardViagens.vue?vue&type=style&index=0&id=74a6ba20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6ba20",
  null
  
)

export default component.exports